<template>
    <div>
      <modal size="large">
        <div slot="header" v-if="player">
            <div class="row columns back">
                Augmentation de niveau
            </div>
            <br>
            <div class="row columns">
                n°{{player.num}} : "{{player.name}}" - {{player.ref_roster_line}}
            </div>
          <br>
          <div class="row columns">
            Vous disposez de <strong>{{player.total_xp}} spp </strong>à dépenser.
          </div>
        </div>
        <div slot="body">
            <div class="row columns">
                <div class="large-12 large-centered">
                    <table>
                        <thead>
                            <tr class="">
                                <th width="15%">Type</th>
                                <th width="15%">Choisi / Aléatoire</th>
                                <th width="15%">Résultat</th>
                                <th width="8%">Coût en Spp</th>
                                <th width="8%">Impact VE</th>
                                <th width="20%"></th>
                                <th width="8%"></th>
                            </tr>
                        </thead>
                        <tbody class="roster" v-if="upgradeList">
                            <tr v-for="upgrade in upgradeList">
                                <td>
                                  <multiselect
                                    v-model="upgrade.type"
                                    :options="typeList"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    :show-labels="false"
                                    label="label"
                                    track-by="id"
                                    @input="onTypeSelected(upgrade)"
                                    :preselect-first="false">
                                  </multiselect>
                                </td>
                                <td>
                                  <multiselect
                                    v-model="upgrade.choice"
                                    :options="choiceList"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    placeholder="progression"
                                    :show-labels="false"
                                    label="label"
                                    :disabled="upgrade.type === -1 || upgrade.type.id === 2"
                                    track-by="id"
                                    @input="onUpdatePrice(upgrade)"
                                    :preselect-first="false">
                                  </multiselect>
                                </td>
                                <td>
                                  <multiselect
                                    v-model="upgrade.result"
                                    :options="getResultList(upgrade.type.id)"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    placeholder="progression"
                                    :show-labels="false"
                                    label="name"
                                    :disabled="upgrade.choice === -1 && upgrade.type.id !== 2"
                                    track-by="id"
                                    @input="onUpdatePrice(upgrade)"
                                    :preselect-first="false">
                                  </multiselect>
                                </td>
                                <td>
                                  {{upgrade.sppCost}}
                                </td>
                                <td>
                                    + {{upgrade.poCost}}
                                </td>
                                <td>{{getskillDesc(upgrade)}}</td>
                              <td>
                                <div>
                                  <button class="small alert line_but" @click="removeUpgradeLine(upgrade)">
                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                        </tbody>
                      <tfoot>
                        <tr>
                          <td class="" colspan="3">Total</td>
                          <td>{{totalSpp}}</td>
                          <td>{{totalPo}}</td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                </div>
              </div>
          <div class="row columns">
            <div class="large-11 large-centered">
              <div class="large-3">
              <button @click="addUpgradeLine" class="full-width" :disabled="preventAddUpgrade">Ajouter une progression</button>
            </div>
            </div>
          </div>
          <div class="row columns" v-if="player">
            il vous restera <strong>{{player.total_xp - totalSpp}} Xp</strong> sur le joueur après validation de ces progressions
          </div>
          </div>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2" @click="publishUpgrade" :disabled="preventValidate">Valider ces progressions</button>
              </div>
          <br>
          </div>
      </modal>
    </div>

</template>
<script>
import modal from './modal.vue'
import playerUpgrade from '../../api/player-upgrade.api'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'playerUpgradeModal',
  components: {
    modal,
    Multiselect
  },
  props: {
    'playerId': null
  },
  data () {
    return {
      typeList: [
        {
          id: 0,
          label: 'Compétence Simple'
        },
        {
          id: 1,
          label: 'Compétence Double'
        },
        {
          id: 2,
          label: 'Augmentation de Carac.'
        }
      ],
      choiceList: [
        {
          id: 0,
          label: 'Aléatoire'
        },
        {
          id: 1,
          label: 'Choisie'
        }
      ],
      statsList: [
        {
          id: 2,
          name: '+1 en M'
        },
        {
          id: 3,
          name: '+1 en Ar'
        },
        {
          id: 4,
          name: '+1 en Ag'
        },
        {
          id: 5,
          name: '+1 en Fo'
        },
        {
          id: 6,
          name: '+1 en Cp'
        }
      ],
      upgradeList: [],
      upgradeCostTable: [
        [null, null, 18, 18, 18, 18, 18, 3, 6, 6, 12],
        [null, null, 20, 20, 20, 20, 20, 4, 8, 8, 14],
        [null, null, 24, 24, 24, 24, 24, 6, 12, 12, 18],
        [null, null, 28, 28, 28, 28, 28, 8, 16, 16, 22],
        [null, null, 32, 32, 32, 32, 32, 10, 20, 20, 26],
        [null, null, 50, 50, 50, 50, 50, 15, 30, 30, 40]
      ],
      upgradePoCostTable: [
        null, null, 20, 10, 40, 80, 20, 10, 20, 20, 40
      ],
      title: null,
      desc: null
    }
  },
  computed:
  {
    ...mapGetters({
      simpleList: 'simpleSkills',
      doubleList: 'doubleSkills',
      player: 'detailedPlayer'
    }),
    playerUpgradeCpt: function () {
      if (!this.player) {
        return 0
      }
      if (this.player.upgrades === null) {
        return 0
      }
      return this.player.upgrades.length
    },
    totalSpp: function () {
      if (this.upgradeList.length === 0) {
        return 0
      }
      return this.upgradeList.map(upg => { return upg.sppCost }).reduce((elem, acc) => { return elem + acc })
    },
    totalPo: function () {
      if (this.upgradeList.length === 0) {
        return 0
      }
      return this.upgradeList.map(upg => { return upg.poCost }).reduce((elem, acc) => { return elem + acc })
    },
    remainingXp: function () {
      if (this.player) {
        return this.player.total_xp - this.totalSpp
      }
    },
    preventAddUpgrade: function () {
      if (!this.player) {
        return true
      }
      let nextUpgradeRow = this.playerUpgradeCpt + this.upgradeList.length
      let minNextUpgrade = this.upgradeCostTable[nextUpgradeRow][7]
      if (this.remainingXp < minNextUpgrade) {
        return true
      }
      return false
    },
    preventValidate: function () {
      if (this.remainingXp < 0) {
        return true
      }
      return false
    }
  },
  watch: {
    upgradeList: function (newVal, oldVal) {
      if (oldVal === null) {
        this.initDatas()
      }
    },
    detailedPlayer: function (newVal, oldVal) {
      this.$store.dispatch('getDoubleSkillList', newVal.ref_roster_line.double_skills)
    }
  },
  methods: {
    getskillDesc (upg) {
      console.log('upg')
      console.log(upg)
      if (!this.simpleList || !this.doubleList) {
        console.log('bof')
        return '-'
      }
      if (upg.type.id === 0 || upg.type.id === 1) {
        return upg.result.desc
      }
      console.log('bif')
      return '-'
    },
    getResultList (type) {
      // cas de la simple
      if (type === 0) {
        return this.simpleList
      } else if (type === 1) {
        return this.doubleList
      } else if (type === 2) {
        return this.statsList
      }
      return []
    },
    onUpdatePrice (upgLine) {
      let upgRef = this.upgradeList.find(upg => { return upg.id === upgLine.id })
      upgRef.sppCost = this.getUpgradeSppCost(upgRef)
      upgRef.poCost = this.getUpgradePOCost(upgRef)
    },
    onTypeSelected (upgLine) {
      let upgRef = this.upgradeList.find(upg => { return upg.id === upgLine.id })
      if (upgLine.type.id === 2) {
        upgRef.choice = -1
        upgRef.result = -1
      } else {
        upgRef.result = -1
      }
      upgRef.sppCost = this.getUpgradeSppCost(upgRef)
      upgRef.poCost = this.getUpgradePOCost(upgRef)
    },
    getUpgradeBackendType (upg) {
      if (upg.type.id === 0) {
        if (upg.choice.id === 0) {
          return 7
        } else if (upg.choice.id === 1) {
          return 8
        }
      } else if (upg.type.id === 1) {
        if (upg.choice.id === 0) {
          return 9
        } else if (upg.choice.id === 1) {
          return 10
        }
      } else if (upg.type.id === 2) {
        return upg.result.id
      }
    },
    addUpgradeLine () {
      let upg = {}
      upg.type = -1
      upg.choice = -1
      upg.result = -1
      upg.sppCost = '-'
      upg.poCost = '-'
      if (!this.upgradeList) {
        upg.id = 0
        Vue.set(this.upgradeList, 0, upg)
      } else {
        upg.id = this.upgradeList.length
        Vue.set(this.upgradeList, this.upgradeList.length, upg)
      }
    },
    removeUpgradeLine (upg) {
      this.upgradeList.splice(upg.id, 1)
      let cpt = 0
      this.upgradeList.forEach(upg => {
        upg.id = cpt
        upg.sppCost = this.getUpgradeSppCost(upg)
        cpt = cpt + 1
      })
    },
    getUpgradeSppCost (upgLine) {
      if (upgLine.type === -1) {
        return 0
      }
      if (upgLine.choice === -1 && upgLine.type.id !== 2) {
        return 0
      }
      if (upgLine.type.id === 2 && upgLine.result === -1) {
        return 0
      }
      let upgradeRow = this.playerUpgradeCpt + upgLine.id
      let upgBackendType = this.getUpgradeBackendType(upgLine)
      return this.upgradeCostTable[upgradeRow][upgBackendType]
    },
    getUpgradePOCost (upg) {
      let upgBackendType = this.getUpgradeBackendType(upg)
      return this.upgradePoCostTable[upgBackendType]
    },
    publishUpgrade () {
      let updates = []
      this.upgradeList.forEach(up => {
        if (up.type === -1 ||
          (up.choice === -1 && up.type.id !== 2) ||
          (up.result === -1)) {
          return
        }
        let newUp = {}
        newUp.player = this.player.id
        newUp.match = up.match
        newUp.value = this.getUpgradeBackendType(up)
        if (up.type.id === 0 || up.type.id === 1) {
          newUp.skill = up.result.id
        }
        newUp.status = 1
        newUp.type = 1
        updates.push(newUp)
      })
      playerUpgrade.api.bulkCreatePlayerUpgrade(updates)
      .then(response => {
        this.$emit('updatePublished')
      }, error => {
        console.log('impossible to create week from create week from create week modal')
        console.log(error)
      })
    }
  },
  created () {
    this.$store.dispatch('invalidateSkillList')
    this.$store.dispatch('purgeUpgradeList')
    this.$store.dispatch('getDetailedPlayer', this.playerId)
    this.$store.dispatch('getSkillsForPlayer', this.playerId)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position:fixed
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

</style>



// WEBPACK FOOTER //
// player-upgrade-modal.vue?62220ae5